import { render, staticRenderFns } from "./TestAr.vue?vue&type=template&id=168b093a&scoped=true&"
import script from "./TestAr.vue?vue&type=script&lang=js&"
export * from "./TestAr.vue?vue&type=script&lang=js&"
import style0 from "./TestAr.vue?vue&type=style&index=0&id=168b093a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b093a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168b093a')) {
      api.createRecord('168b093a', component.options)
    } else {
      api.reload('168b093a', component.options)
    }
    module.hot.accept("./TestAr.vue?vue&type=template&id=168b093a&scoped=true&", function () {
      api.rerender('168b093a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/components/TestAr.vue"
export default component.exports